export enum Feld {
    HEADER_BASISDATA = 'HEADER_BASISDATA',
    FIELD_GUELTIG_AB = 'FIELD_GUELTIG_AB',
    FIELD_VERGUETUNGSART = 'FIELD_VERGUETUNGSART',
    FIELD_ANLAGENSCHLUESSEL = 'FIELD_ANLAGENSCHLUESSEL',
    FIELD_ENERGIETRAEGER = 'FIELD_ENERGIETRAEGER',
    FIELD_BEZ_VNB_INTERN = 'FIELD_BEZ_VNB_INTERN',
    HEADER_NETZZUORDNUNG = 'HEADER_NETZZUORDNUNG',
    FIELD_NETZZUORDNUNG_ORTSNAME = 'FIELD_NETZZUORDNUNG_ORTSNAME',
    FIELD_NETZZUORDNUNG_STATIONSNAME = 'FIELD_NETZZUORDNUNG_STATIONSNAME',
    FIELD_NETZZUORDNUNG_TRAFOFELD = 'FIELD_NETZZUORDNUNG_TRAFOFELD',
    HEADER_LOKATION = 'HEADER_LOKATION',
    FIELD_ANSCHRIFT_ANLAGE_PLZ = 'FIELD_ANSCHRIFT_ANLAGE_PLZ',
    FIELD_ANSCHRIFT_ANLAGE_GEMEINDE = 'FIELD_ANSCHRIFT_ANLAGE_GEMEINDE',
    FIELD_ANSCHRIFT_ANLAGE_STRASSE = 'FIELD_ANSCHRIFT_ANLAGE_STRASSE',
    FIELD_ANSCHRIFT_ANLAGE_HAUSNR = 'FIELD_ANSCHRIFT_ANLAGE_HAUSNR',
    FIELD_ANSCHRIFT_ANLAGE_HAUSNR_ZUSATZ = 'FIELD_ANSCHRIFT_ANLAGE_HAUSNR_ZUSATZ',
    FIELD_GEOKOORDINATEN_SYSTEM = 'FIELD_GEOKOORDINATEN_SYSTEM',
    FIELD_GEOKOORDINATEN_DEZIMALGRAD_LONGITUDE = 'FIELD_GEOKOORDINATEN_DEZIMALGRAD_LONGITUDE',
    FIELD_GEOKOORDINATEN_DEZIMALGRAD_LATITUDE = 'FIELD_GEOKOORDINATEN_DEZIMALGRAD_LATITUDE',
    FIELD_GEOKOORDINATEN_UTM_ZONE = 'FIELD_GEOKOORDINATEN_UTM_ZONE',
    FIELD_GEOKOORDINATEN_UTM_HOCHWERT = 'FIELD_GEOKOORDINATEN_UTM_HOCHWERT',
    FIELD_GEOKOORDINATEN_UTM_RECHTSWERT = 'FIELD_GEOKOORDINATEN_UTM_RECHTSWERT',
    HEADER_LEISTUNG = 'HEADER_LEISTUNG',
    FIELD_BRUTTO_NENNLEISTUNG = 'FIELD_BRUTTO_NENNLEISTUNG',
    FIELD_BLINDLEISTUNGSVERFAHREN = 'FIELD_BLINDLEISTUNGSVERFAHREN',
    HEADER_STEUERUNG = 'HEADER_STEUERUNG',
    FIELD_ABREGELMOEGLICHKEIT = 'FIELD_ABREGELMOEGLICHKEIT',
    SUB_HEADER_FRE = 'SUB_HEADER_FRE',
    SUB_HEADER_FWA = 'SUB_HEADER_FWA',
    FIELD_FWA_FRE_ID_FERNWIRKGERAET = 'FIELD_FWA_FRE_ID_FERNWIRKGERAET',
    FIELD_FRE_PLZ = 'FIELD_FRE_PLZ',
    FIELD_FRE_ANWENDERADRESSE = 'FIELD_FRE_ANWENDERADRESSE',
    FIELD_FRE_ENERGIEART = 'FIELD_FRE_ENERGIEART',
    FIELD_FRE_LEISTUNGSKLASSE = 'FIELD_FRE_LEISTUNGSKLASSE',
    SUB_HEADER_TASE2 = 'SUB_HEADER_TASE2',
    FIELD_TASE2_VERBINDUNGSNAME = 'FIELD_TASE2_VERBINDUNGSNAME',
    FIELD_TASE2_ABREGELUNGSTYP = 'FIELD_TASE2_ABREGELUNGSTYP',
    TABLEHEADER_TASE2_ADRESSIERUNG = 'TABLEHEADER_TASE2_ADRESSIERUNG',
    TABLEHEADER_TASE2_OBJEKT = 'TABLEHEADER_TASE2_OBJEKT',
    TABLEHEADER_TASE2_ELEMENTTYP = 'TABLEHEADER_TASE2_ELEMENTTYP',
    FIELD_TASE2_SOLLWERT_KOPPLUNGSTYP = 'FIELD_TASE2_SOLLWERT_KOPPLUNGSTYP',
    FIELD_TASE2_SOLLWERT_TASE2OBJEKT = 'FIELD_TASE2_SOLLWERT_TASE2OBJEKT',
    FIELD_TASE2_SOLLWERT_ELEMENTTYP = 'FIELD_TASE2_SOLLWERT_ELEMENTTYP',
    FIELD_TASE2_100_KOPPLUNGSTYP = 'FIELD_TASE2_100_KOPPLUNGSTYP',
    FIELD_TASE2_100_TASE2OBJEKT = 'FIELD_TASE2_100_TASE2OBJEKT',
    FIELD_TASE2_100_ELEMENTTYP = 'FIELD_TASE2_100_ELEMENTTYP',
    FIELD_TASE2_60_KOPPLUNGSTYP = 'FIELD_TASE2_60_KOPPLUNGSTYP',
    FIELD_TASE2_60_TASE2OBJEKT = 'FIELD_TASE2_60_TASE2OBJEKT',
    FIELD_TASE2_60_ELEMENTTYP = 'FIELD_TASE2_60_ELEMENTTYP',
    FIELD_TASE2_30_KOPPLUNGSTYP = 'FIELD_TASE2_30_KOPPLUNGSTYP',
    FIELD_TASE2_30_TASE2OBJEKT = 'FIELD_TASE2_30_TASE2OBJEKT',
    FIELD_TASE2_30_ELEMENTTYP = 'FIELD_TASE2_30_ELEMENTTYP',
    FIELD_TASE2_0_KOPPLUNGSTYP = 'FIELD_TASE2_0_KOPPLUNGSTYP',
    FIELD_TASE2_0_TASE2OBJEKT = 'FIELD_TASE2_0_TASE2OBJEKT',
    FIELD_TASE2_0_ELEMENTTYP = 'FIELD_TASE2_0_ELEMENTTYP',
    FIELD_TASE2_WIRKLEISTUNG_KOPPLUNGSTYP = 'FIELD_TASE2_WIRKLEISTUNG_KOPPLUNGSTYP',
    FIELD_TASE2_WIRKLEISTUNG_TASE2OBJEKT = 'FIELD_TASE2_WIRKLEISTUNG_TASE2OBJEKT',
    FIELD_TASE2_WIRKLEISTUNG_ELEMENTTYP = 'FIELD_TASE2_WIRKLEISTUNG_ELEMENTTYP',
    FIELD_TASE2_BLINDLEISTUNG_KOPPLUNGSTYP = 'FIELD_TASE2_BLINDLEISTUNG_KOPPLUNGSTYP',
    FIELD_TASE2_BLINDLEISTUNG_TASE2OBJEKT = 'FIELD_TASE2_BLINDLEISTUNG_TASE2OBJEKT',
    FIELD_TASE2_BLINDLEISTUNG_ELEMENTTYP = 'FIELD_TASE2_BLINDLEISTUNG_ELEMENTTYP',
    SUB_HEADER_IEC = 'SUB_HEADER_IEC',
    FIELD_IEC_GEMEINSAME_ASDU_ADRESSE = 'FIELD_IEC_GEMEINSAME_ASDU_ADRESSE',
    FIELD_IEC_ABREGELUNGSTYP = 'FIELD_IEC_ABREGELUNGSTYP',
    TABLEHEADER_IEC_ADRESSIERUNG = 'TABLEHEADER_IEC_ADRESSIERUNG',
    TABLEHEADER_IEC_HOHES_BYTE = 'TABLEHEADER_IEC_HOHES_BYTE',
    TABLEHEADER_IEC_MITTLERES_BYTE = 'TABLEHEADER_IEC_MITTLERES_BYTE',
    TABLEHEADER_IEC_NIEDRIGES_BYTE = 'TABLEHEADER_IEC_NIEDRIGES_BYTE',
    TABLEHEADER_IEC_TYPKENNUNG = 'TABLEHEADER_IEC_TYPKENNUNG',
    FIELD_IEC_SOLLWERT_KOPPLUNGSTYP = 'FIELD_IEC_SOLLWERT_KOPPLUNGSTYP',
    FIELD_IEC_SOLLWERT_HOHES_BYTE = 'FIELD_IEC_SOLLWERT_HOHES_BYTE',
    FIELD_IEC_SOLLWERT_MITTLERES_BYTE = 'FIELD_IEC_SOLLWERT_MITTLERES_BYTE',
    FIELD_IEC_SOLLWERT_NIEDRIGES_BYTE = 'FIELD_IEC_SOLLWERT_NIEDRIGES_BYTE',
    FIELD_IEC_SOLLWERT_TYPKENNUNG = 'FIELD_IEC_SOLLWERT_TYPKENNUNG',
    FIELD_IEC_100_KOPPLUNGSTYP = 'FIELD_IEC_100_KOPPLUNGSTYP',
    FIELD_IEC_100_HOHES_BYTE = 'FIELD_IEC_100_HOHES_BYTE',
    FIELD_IEC_100_MITTLERES_BYTE = 'FIELD_IEC_100_MITTLERES_BYTE',
    FIELD_IEC_100_NIEDRIGES_BYTE = 'FIELD_IEC_100_NIEDRIGES_BYTE',
    FIELD_IEC_100_TYPKENNUNG = 'FIELD_IEC_100_TYPKENNUNG',
    FIELD_IEC_60_KOPPLUNGSTYP = 'FIELD_IEC_60_KOPPLUNGSTYP',
    FIELD_IEC_60_HOHES_BYTE = 'FIELD_IEC_60_HOHES_BYTE',
    FIELD_IEC_60_MITTLERES_BYTE = 'FIELD_IEC_60_MITTLERES_BYTE',
    FIELD_IEC_60_NIEDRIGES_BYTE = 'FIELD_IEC_60_NIEDRIGES_BYTE',
    FIELD_IEC_60_TYPKENNUNG = 'FIELD_IEC_60_TYPKENNUNG',
    FIELD_IEC_30_KOPPLUNGSTYP = 'FIELD_IEC_30_KOPPLUNGSTYP',
    FIELD_IEC_30_HOHES_BYTE = 'FIELD_IEC_30_HOHES_BYTE',
    FIELD_IEC_30_MITTLERES_BYTE = 'FIELD_IEC_30_MITTLERES_BYTE',
    FIELD_IEC_30_NIEDRIGES_BYTE = 'FIELD_IEC_30_NIEDRIGES_BYTE',
    FIELD_IEC_30_TYPKENNUNG = 'FIELD_IEC_30_TYPKENNUNG',
    FIELD_IEC_0_KOPPLUNGSTYP = 'FIELD_IEC_0_KOPPLUNGSTYP',
    FIELD_IEC_0_HOHES_BYTE = 'FIELD_IEC_0_HOHES_BYTE',
    FIELD_IEC_0_MITTLERES_BYTE = 'FIELD_IEC_0_MITTLERES_BYTE',
    FIELD_IEC_0_NIEDRIGES_BYTE = 'FIELD_IEC_0_NIEDRIGES_BYTE',
    FIELD_IEC_0_TYPKENNUNG = 'FIELD_IEC_0_TYPKENNUNG',
    FIELD_IEC_WIRKLEISTUNG_KOPPLUNGSTYP = 'FIELD_IEC_WIRKLEISTUNG_KOPPLUNGSTYP',
    FIELD_IEC_WIRKLEISTUNG_HOHES_BYTE = 'FIELD_IEC_WIRKLEISTUNG_HOHES_BYTE',
    FIELD_IEC_WIRKLEISTUNG_MITTLERES_BYTE = 'FIELD_IEC_WIRKLEISTUNG_MITTLERES_BYTE',
    FIELD_IEC_WIRKLEISTUNG_NIEDRIGES_BYTE = 'FIELD_IEC_WIRKLEISTUNG_NIEDRIGES_BYTE',
    FIELD_IEC_WIRKLEISTUNG_TYPKENNUNG = 'FIELD_IEC_WIRKLEISTUNG_TYPKENNUNG',
    FIELD_IEC_BLINDLEISTUNG_KOPPLUNGSTYP = 'FIELD_IEC_BLINDLEISTUNG_KOPPLUNGSTYP',
    FIELD_IEC_BLINDLEISTUNG_HOHES_BYTE = 'FIELD_IEC_BLINDLEISTUNG_HOHES_BYTE',
    FIELD_IEC_BLINDLEISTUNG_MITTLERES_BYTE = 'FIELD_IEC_BLINDLEISTUNG_MITTLERES_BYTE',
    FIELD_IEC_BLINDLEISTUNG_NIEDRIGES_BYTE = 'FIELD_IEC_BLINDLEISTUNG_NIEDRIGES_BYTE',
    FIELD_IEC_BLINDLEISTUNG_TYPKENNUNG = 'FIELD_IEC_BLINDLEISTUNG_TYPKENNUNG',
    HEADER_RESOURCE_IDS = 'HEADER_RESOURCE_IDS',
    FIELD_REDISPATCH_RELEVANT = 'FIELD_REDISPATCH_RELEVANT',
    HEADER_REDISPATCH_SR = 'HEADER_REDISPATCH_SR',
    FIELD_ANSCHLUSS_NETZBETREIBER = 'FIELD_ANSCHLUSS_NETZBETREIBER',
    FIELD_ANWEISENDER_NETZBETREIBER = 'FIELD_ANWEISENDER_NETZBETREIBER',
    FIELD_BETROFFENER_NETZBETREIBER = 'FIELD_BETROFFENER_NETZBETREIBER',
    FIELD_WEITERE_BETROFFENE_NETZBETREIBER = 'FIELD_WEITERE_BETROFFENE_NETZBETREIBER',
    FIELD_ABRECHNUNGSKLASSE = 'FIELD_ABRECHNUNGSKLASSE',
    FIELD_REGELSTUFE = 'FIELD_REGELSTUFE',
    FIELD_BILANZIERUNGSMODELL = 'FIELD_BILANZIERUNGSMODELL',
    FIELD_REGELZONE = 'FIELD_REGELZONE',
    HEADER_REDISPATCH_TR = 'HEADER_REDISPATCH_TR',
    FIELD_STEUERBARE_RESOURCE_ID = 'FIELD_STEUERBARE_RESOURCE_ID',
    FIELD_TECHNISCHE_RESOURCE_ID = 'FIELD_TECHNISCHE_RESOURCE_ID',
    FIELD_STEUERGRUPPE_ID = 'FIELD_STEUERGRUPPE_ID',
    FIELD_MARKT_STAMMDATENREGISTER_NUMMER = 'FIELD_MARKT_STAMMDATENREGISTER_NUMMER',
    FIELD_ANLAGEN_TYPE = 'FIELD_ANLAGEN_TYPE',
    FIELD_ZUORDNUNG_SPEICHER = 'FIELD_ZUORDNUNG_SPEICHER',
    FIELD_AB_NAME = 'FIELD_AB_NAME',
    FIELD_AB_STRASSE = 'FIELD_AB_STRASSE',
    FIELD_AB_HNR = 'FIELD_AB_HNR',
    FIELD_AB_HNR_ZUSATZ = 'FIELD_AB_HNR_ZUSATZ',
    FIELD_AB_PLZ = 'FIELD_AB_PLZ',
    FIELD_AB_ORT = 'FIELD_AB_ORT',
    HEADER_TR_MARKTLOKATION = 'HEADER_TR_MARKTLOKATION',
    FIELD_MARKTLOKATION_CODE = 'FIELD_MARKTLOKATION_CODE',
    FIELD_MARKTLOKATION_BILANZKREIS = 'FIELD_MARKTLOKATION_BILANZKREIS',
    FIELD_MARKTLOKATION_SPANNUNGSEBENE = 'FIELD_MARKTLOKATION_SPANNUNGSEBENE',
    FIELD_NETZEBENE_DES_NETZANSCHLUSSPUNKTES = 'FIELD_NETZEBENE_DES_NETZANSCHLUSSPUNKTES',
    FIELD_MARKTLOKATION_MESSLOKATION_ID = 'FIELD_MARKTLOKATION_MESSLOKATION_ID',
    FIELD_MARKTLOKATION_LIEFERANT = 'FIELD_MARKTLOKATION_LIEFERANT',
    HEADER_TR_TRANCHE = 'HEADER_TR_TRANCHE',
    FIELD_TRANCE_MARKTLOKATION = 'FIELD_TRANCE_MARKTLOKATION',
    FIELD_TRANCE_BILANZKREIS = 'FIELD_TRANCE_BILANZKREIS',
    FIELD_TRANCE_LIEFERANT = 'FIELD_TRANCE_LIEFERANT',
    FIELD_TRANCE_GROESSE = 'FIELD_TRANCE_GROESSE',
    HEADER_TR_BETRIEB = 'HEADER_TR_BETRIEB',
    FIELD_ERSTMALIGER_INBETRIEBNAMEZEITPUNKT = 'FIELD_ERSTMALIGER_INBETRIEBNAMEZEITPUNKT',
    FIELD_KOMMERZIELLER_INBETRIEBNAMEZEITPUNKT = 'FIELD_KOMMERZIELLER_INBETRIEBNAMEZEITPUNKT',
    FIELD_STILLLEGUNGSZEITPUNKT_VORLAEUFIG = 'FIELD_STILLLEGUNGSZEITPUNKT_VORLAEUFIG',
    FIELD_STILLLEGUNGSZEITPUNKT_ENDGUELTIG = 'FIELD_STILLLEGUNGSZEITPUNKT_ENDGUELTIG',
    HEADER_TR_LEISTUNG = 'HEADER_TR_LEISTUNG',
    FIELD_NETTO_NENNLEISTUNG_PROD = 'FIELD_NETTO_NENNLEISTUNG_PROD',
    FIELD_NETTO_NENNLEISTUNG_VERBRAUCH = 'FIELD_NETTO_NENNLEISTUNG_VERBRAUCH',
    FIELD_NETTO_ENGPASSLEISTUNG_PROD = 'FIELD_NETTO_ENGPASSLEISTUNG_PROD',
    FIELD_NETTO_ENGPASSLEISTUNG_VERBRAUCH = 'FIELD_NETTO_ENGPASSLEISTUNG_VERBRAUCH',
    HEADER_TR_ABRECHNUNG = 'HEADER_TR_ABRECHNUNG',
    FIELD_ABRECHNUNGSMODELL = 'FIELD_ABRECHNUNGSMODELL',
    FIELD_DATENQUELLE_SPITZ_LIGHT_MODELL = 'FIELD_DATENQUELLE_SPITZ_LIGHT_MODELL',
    FIELD_AUSGEWAEHLTER_WETTERDIENSTLEISTER = 'FIELD_AUSGEWAEHLTER_WETTERDIENSTLEISTER',
    FIELD_ZUGEORDNETE_REFERENZANLAGE = 'FIELD_ZUGEORDNETE_REFERENZANLAGE',
    HEADER_TR_SOLAR = 'HEADER_TR_SOLAR',
    FIELD_WECHSELRICHTERLEISTUNG_KUMULIERT = 'FIELD_WECHSELRICHTERLEISTUNG_KUMULIERT',
    FIELD_AUSRICHTUNG_PV_MODULE = 'FIELD_AUSRICHTUNG_PV_MODULE',
    FIELD_NEIGUNGSWINKEL_PV_MODULE = 'FIELD_NEIGUNGSWINKEL_PV_MODULE',
    FIELD_ABSENKUNG_70 = 'FIELD_ABSENKUNG_70',
    HEADER_TR_WIND = 'HEADER_TR_WIND',
    FIELD_ANLAGENHERSTELLER = 'FIELD_ANLAGENHERSTELLER',
    FIELD_ANLAGENTYP = 'FIELD_ANLAGENTYP',
    FIELD_NABENHOEHE = 'FIELD_NABENHOEHE',
    FIELD_REFERENZERTRAG_WEA = 'FIELD_REFERENZERTRAG_WEA',
    FIELD_NACHTABSENKUNGSWERT = 'FIELD_NACHTABSENKUNGSWERT',
    HEADER_TR_WIND_ANLAGENKENNLINIE = 'HEADER_TR_WIND_ANLAGENKENNLINIE',
    FIELD_AK_01MS = 'FIELD_AK_01MS',
    FIELD_AK_02MS = 'FIELD_AK_02MS',
    FIELD_AK_03MS = 'FIELD_AK_03MS',
    FIELD_AK_04MS = 'FIELD_AK_04MS',
    FIELD_AK_05MS = 'FIELD_AK_05MS',
    FIELD_AK_06MS = 'FIELD_AK_06MS',
    FIELD_AK_07MS = 'FIELD_AK_07MS',
    FIELD_AK_08MS = 'FIELD_AK_08MS',
    FIELD_AK_09MS = 'FIELD_AK_09MS',
    FIELD_AK_10MS = 'FIELD_AK_10MS',
    FIELD_AK_11MS = 'FIELD_AK_11MS',
    FIELD_AK_12MS = 'FIELD_AK_12MS',
    FIELD_AK_13MS = 'FIELD_AK_13MS',
    FIELD_AK_14MS = 'FIELD_AK_14MS',
    FIELD_AK_15MS = 'FIELD_AK_15MS',
    FIELD_AK_16MS = 'FIELD_AK_16MS',
    FIELD_AK_17MS = 'FIELD_AK_17MS',
    FIELD_AK_18MS = 'FIELD_AK_18MS',
    FIELD_AK_19MS = 'FIELD_AK_19MS',
    FIELD_AK_20MS = 'FIELD_AK_20MS',
    FIELD_AK_21MS = 'FIELD_AK_21MS',
    FIELD_AK_22MS = 'FIELD_AK_22MS',
    FIELD_AK_23MS = 'FIELD_AK_23MS',
    FIELD_AK_24MS = 'FIELD_AK_24MS',
    FIELD_AK_25MS = 'FIELD_AK_25MS',
    FIELD_AK_26MS = 'FIELD_AK_26MS',
    FIELD_AK_27MS = 'FIELD_AK_27MS',
    FIELD_AK_28MS = 'FIELD_AK_28MS',
    FIELD_AK_29MS = 'FIELD_AK_29MS',
    FIELD_AK_30MS = 'FIELD_AK_30MS',
    FIELD_AK_31MS = 'FIELD_AK_31MS',
    FIELD_AK_32MS = 'FIELD_AK_32MS',
    FIELD_AK_33MS = 'FIELD_AK_33MS',
    FIELD_AK_34MS = 'FIELD_AK_34MS',
    FIELD_AK_35MS = 'FIELD_AK_35MS',
    HEADER_TR_SPEICHER = 'HEADER_TR_SPEICHER',
    FIELD_WIRKLEISTUNG_AUSSPEICHERN_MAX = 'FIELD_WIRKLEISTUNG_AUSSPEICHERN_MAX',
    FIELD_NUTZBARER_ENERGIEINHALT_SPEICHER = 'FIELD_NUTZBARER_ENERGIEINHALT_SPEICHER'
}
